<ng-container *ngIf="(activated$ | async) === true">
    <button class="btn btn-clear ttu btn-tertiary text-l" (click)="show()" *ngIf="(loaded$ | async) === true">
        <ng-container *ngIf="(recommendedSize$ | async) === null"> {{ 'dev.sastre.mandatory_recommender_title' | translate }} </ng-container>
        <ng-container *ngIf="(recommendedSize$ | async) !== null">
            {{ 'dev.sastre.recommended_size_talla' | translate }} {{ recommendedSize$ | async }}
        </ng-container>
    </button>
</ng-container>
